import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import InformacoesPaciente from 'views/WizardGerente/InformacoesPaciente';
import DadosSolicitacao from 'views/WizardGerente/DadosSolicitacao';
import ItensCirurgia from 'views/WizardGerente/ItensCirurgia';
import Documentos from 'views/WizardGerente/Documentos';
import Resumo from 'views/WizardGerente/Resumo';
import ConfirmacaoPedido from 'views/Wizard/ConfirmacaoPedido';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Dialog } from 'primereact/dialog';
import { Button as ButtonPrime } from 'primereact/button';
import { isMobile } from 'react-device-detect';
import { FaSpinner } from 'react-icons/fa';
import { Dialog as DialogPrime } from 'primereact/dialog';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { dominioDemandaCirurgica, dominioNODE } from '../../config/database';
import DataCirurgia from './DataCirurgia';
import moment from 'moment';

import 'assets/css/geral.css';
import { Toast } from 'primereact/toast';
import { isValid, isAfter, isBefore } from 'date-fns';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: '80vw',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = ['Paciente', 'Solicitação', 'Cirurgia', 'Itens', /* 'Documentos', */ 'Resumo'];

export default function WizardGerente(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [redireciona, setRedireciona] = React.useState(false);
  const [displayBasic, setDisplayBasica] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [abrirMensagemErro, setAbrirMensagemErro] = React.useState(false);
  const [mensagemErro, setMensagemErro] = React.useState('');
  const [configuracoes, setConfiguracoes] = React.useState(null);
  const [finalEfetivoCirurgia, setFinalEfetivoCirurgia] = React.useState(null);
  const [abreModalReagendar, setAbreModalReagendar] = React.useState(false);
  const [motivoReagendamentoSelecionado, setMotivoReagendamentoSelecionado] = React.useState(null);
  const [listaMotivosReagendamento, setListaMotivosReagendamento] = React.useState([]);
  const [dataSugeridaStorage, setDataSugeridaStorage] = React.useState(localStorage.getItem('dataSugerida'));
  const [dataInternacaoStorage, setDataInternacaoStorage] = React.useState(localStorage.getItem('dataInternacao'));
  const [centroCirurgicoStorage, setCentroCirurgicoStorage] = React.useState(JSON.parse(localStorage.getItem('centroCirurgico'))?.id);
  const [caraterStorage, setCaraterStorage] = React.useState(JSON.parse(localStorage.getItem('carater'))?.id);
  const [modalidadeAmbulatorial, setModalidadeAmbulatorial] = React.useState(JSON.parse(localStorage.getItem('configuracoes'))?.modalidadeAmbulatorial);
  const camposLOG = [
    'convenio',
    'peso',
    'paciente',
    'atendimento',
    'dataSugerida',
    'centroCirurgico',
    'lateralidade',
    'indicacaoClinica',
    'prioridade',
    'cidPrincipal',
    'cidsSecundarios',
    'tipoAcomodacao',
    'diariasPrevistas',
    'leitoUTI',
    'tipoAnestesia',
    'carater',
    'equipeRequisitante',
    'profissionalRequisitante',
    'procedimentoPrincipal',
    'procedimentosSecundarios',
    'duracaoEstimada',
    'pedidoCirurgia',
    'caixasOPME',
    'materiaisConsumiveis',
    'caixasCirurgicas',
    'hemoderivados',
    'equipamentos',
    'celular',
    'telefone',
    'email',
  ];

  const getConfiguracoes = () => {
    setConfiguracoes(JSON.parse(localStorage.getItem('configuracoes')));
  };

  const myToast = useRef(null);

  useEffect(() => {
    dominioDemandaCirurgica.get('/api/motivoReagendamento').then(
      response => {
        setListaMotivosReagendamento(response.data);
      },
      err => {
        myToast.current.show({
          severity: 'info',
          summary: 'Erro ao listar motivos para reagendamento!',
          detail: `${err.data.mensagem}`,
          life: 3000,
        });
      }
    );

    getConfiguracoes();

    const step = localStorage.getItem('activeStep');

    if (step) setActiveStep(parseInt(step, 10));
  }, []);

  useEffect(() => {
    localStorage.setItem('activeStep', activeStep);
    localStorage.setItem('completed', Object.keys(completed).length);
  }, [activeStep, completed]);

  function congelaPedido() {
    camposLOG.forEach(campo => {
      localStorage.setItem(`LOG_${campo}`, localStorage.getItem(campo));
    });
  }

  useEffect(() => {
    congelaPedido();
  }, []);

  const verificaPendenciasStep = step => {
    const modalidadeAtendimento = JSON.parse(localStorage.getItem('modalidadeAtendimento'));

    if (step === 0) {
      const pendenciasPaciente = JSON.parse(localStorage.getItem('pendenciasPaciente'));
      if (pendenciasPaciente.length > 0) {
        let arrayMensagens = [];
        pendenciasPaciente.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            { severity: 'warn', summary: 'Atenção', detail: `Informe ${validacao}`, life: '3000' },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
      const email = localStorage.getItem('email');

      if (email && email !== 'null') {
        if (!email.includes('@')) {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Formato inválido de email',
          });
          return false;
        }
      }
    }
    if (step >= 1) {
      const pendenciasSolicitacao = JSON.parse(localStorage.getItem('pendenciasSolicitacao'));
      if (pendenciasSolicitacao.length > 0) {
        let arrayMensagens = [];
        pendenciasSolicitacao.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            { severity: 'warn', summary: 'Atenção', detail: `Informe ${validacao}`, life: '3000' },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
    }

    /* if (step >= 2) {
      const pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));
      if (pendenciasCirurgia.length > 0) {
        let arrayMensagens = [];
        pendenciasCirurgia.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            { severity: 'warn', summary: 'Atenção', detail: `Informe ${validacao}`, life: '3000' },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
    } */

    if (step >= 2) {
      let dataSugerida = Date.parse(localStorage.getItem('dataSugerida'));

      const hoje = new Date().setHours(0, 0, 0, 0);
      if (isAfter(hoje, dataSugerida)) {
        myToast.current.show({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Data não pode ser retroativa',
        });
        return false;
      }

      if (!isValid(dataSugerida)) {
        myToast.current.show({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Data inválida',
        });
        return false;
      }

      let dataInternacao = Date.parse(localStorage.getItem('dataInternacao'));
      const motivoAntecipacaoInternacao = localStorage.getItem('motivoAntecipacaoInternacao') ?? null;
      let internacao = localStorage.getItem('internacao');

      if (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
        internacao = null;

      if (!internacao) {
        if (dataInternacao) {
          dataSugerida = new Date(localStorage.getItem('dataSugerida'));
          dataInternacao = new Date(localStorage.getItem('dataInternacao'));
          dataInternacao.setDate(dataInternacao.getDate() + 1);

          const dataSugeridaSemHoras = new Date(dataSugerida.getFullYear(), dataSugerida.getMonth(), dataSugerida.getDate());
          const dataInternacaoSemHoras = new Date(dataInternacao.getFullYear(), dataInternacao.getMonth(), dataInternacao.getDate());

          if (isBefore(dataInternacaoSemHoras, dataSugeridaSemHoras) && motivoAntecipacaoInternacao === null) {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'É necessário informar o motivo da internação antecipada!',
            });

            return false;
          }
        } else if (modalidadeAtendimento?.id !== modalidadeAmbulatorial) {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'É necessário informar a data de internação',
          });

          return false;
        }
      }
    }

    return true;
  };

  const handleStep = step => () => {
    if (verificaPendenciasStep(step - 1)) setActiveStep(step);
  };

  const handleNext = () => {
    if (verificaPendenciasStep(activeStep)) {
      setActiveStep(activeStep + 1);
      document.location.href = `${document.location.href.replace(
        '#centroWizard',
        ''
      )}#centroWizard`;
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    document.location.href = `${document.location.href.replace('#centroWizard', '')}#centroWizard`;
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <InformacoesPaciente />;
      case 1:
        return <DadosSolicitacao />;
      case 2:
        return <DataCirurgia />;
      case 3:
        return <ItensCirurgia />;
      /* case 4:
        return <Documentos />; */
      case 4:
        return <Resumo />;
      default:
        throw new Error('Unknown step');
    }
  }

  const limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('equipeRequisitante');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('aprovacaoAutomatica');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
  };

  const handleCancelarPedido = () => {
    limparLocalStorage();

    setActiveStep(0);
    setRedireciona(true);
  };

  const handleConfirmarPedido = async () => {
    setLoading(true);

    const dataSugeridaAlterada = localStorage.getItem('dataSugerida') && localStorage.getItem('dataSugerida') != dataSugeridaStorage;
    const dataInternacaoAlterada = localStorage.getItem('dataInternacao') && localStorage.getItem('dataInternacao').replace(/["']/g, '') != dataInternacaoStorage.replace(/["']/g, '');

    const dataAlterada = dataSugeridaAlterada || dataInternacaoAlterada;
    const centroCirurgicoAlterado = centroCirurgicoStorage != JSON.parse(localStorage.getItem('centroCirurgico'))?.id;
    const caraterAlterado = caraterStorage != JSON.parse(localStorage.getItem('carater'))?.id;

    if ((dataAlterada || centroCirurgicoAlterado || caraterAlterado) && !motivoReagendamentoSelecionado) {
      setAbreModalReagendar(true);
      setLoading(false);

      return false;
    }

    const paciente = JSON.parse(localStorage.getItem('paciente'));
    const atendimento = JSON.parse(localStorage.getItem('atendimento'));
    const convenio = JSON.parse(localStorage.getItem('convenio'));
    const peso = localStorage.getItem('peso');
    const carater = JSON.parse(localStorage.getItem('carater'));
    const profissionalResponsavel = JSON.parse(localStorage.getItem('profissionalResponsavel'));
    const dataSugerida = localStorage.getItem('dataSugerida');
    const centroCirurgico = JSON.parse(localStorage.getItem('centroCirurgico'));
    const lateralidade = localStorage.getItem('lateralidade');
    const indicacaoClinica = localStorage.getItem('indicacaoClinica');
    const prioridade = JSON.parse(localStorage.getItem('prioridade'));
    const cidPrincipal = JSON.parse(localStorage.getItem('cidPrincipal'));
    const cidsSecundarios = JSON.parse(localStorage.getItem('cidsSecundarios'));
    const tipoAcomodacao = JSON.parse(localStorage.getItem('tipoAcomodacao'));
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const leitoUTI = localStorage.getItem('leitoUTI');
    const tipoAnestesia = JSON.parse(localStorage.getItem('tipoAnestesia'));
    const equipeRequisitante = JSON.parse(localStorage.getItem('equipeRequisitante'));
    const profissionalRequisitante = JSON.parse(localStorage.getItem('profissionalRequisitante'));
    const caixasOPME = JSON.parse(localStorage.getItem('caixasOPME'));
    const materiaisConsumiveis = JSON.parse(localStorage.getItem('materiaisConsumiveis'));
    const caixasCirurgicas = JSON.parse(localStorage.getItem('caixasCirurgicas'));
    const hemoderivados = JSON.parse(localStorage.getItem('hemoderivados'));
    const procedimentoPrincipal = JSON.parse(localStorage.getItem('procedimentoPrincipal'));
    const procedimentosSecundarios = JSON.parse(localStorage.getItem('procedimentosSecundarios'));
    const pedidoCirurgia = JSON.parse(localStorage.getItem('pedidoCirurgia'));
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    const equipamentos = JSON.parse(localStorage.getItem('equipamentos'));
    const duracaoEstimada = localStorage.getItem('duracaoEstimada');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const exames = JSON.parse(localStorage.getItem('exames'));
    const tipoPedido = localStorage.getItem('tipoPedido') ?? '0';
    const tipoPedidoSuplementar = '1';
    const salaCirurgia = JSON.parse(localStorage.getItem('salaCirurgia'));
    let dataInternacao = localStorage.getItem('dataInternacao');
    if (dataInternacao === 'null') {
      dataInternacao = null;
    } else if (dataInternacao) {
      const data = new Date(dataInternacao.substring(0, 11));
      dataInternacao = data;
    }
    const motivoAntecipacaoInternacao = JSON.parse(
      localStorage.getItem('motivoAntecipacaoInternacao')
    );
    let motivoAvaliacaoAnestesica = localStorage.getItem('motivoAvaliacaoAnestesica');
    if (motivoAvaliacaoAnestesica === 'null') motivoAvaliacaoAnestesica = null;
    const necessariaAvaliacaoAnestesica = JSON.parse(
      localStorage.getItem('necessariaAvaliacaoAnestesica')
    );
    const codigoLeito = parseInt(pedidoCirurgia.codigoLeito, 10);
    const internacao = JSON.parse(localStorage.getItem('internacao'));
    const modalidadeAtendimento = JSON.parse(localStorage.getItem('modalidadeAtendimento'));
    const novoPaciente = JSON.parse(localStorage.getItem('novoPaciente'));

    //  #region Validações
    if (parseInt(peso, 10) > 500) {
      setMensagemErro('O peso máximo é 500.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (parseInt(diariasPrevistas, 10) > 999) {
      setMensagemErro('O máximo de diárias previstas é 999.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (prioridade === null) {
      setMensagemErro('Informe a prioridade da cirurgia.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }
    //  #endregion

    let idPaciente = 0;
    let idAtendimento = 0;
    let idInternacao = 0;

    try {
      const dataNascimento = new Date(novoPaciente?.dataNascimento ?? paciente.DAT_NASCIMENTO);
      dataNascimento.setDate(dataNascimento.getDate() + 1);
      dataNascimento.setMonth(dataNascimento.getMonth());
      const dataNascimentoFormat = `${dataNascimento.getFullYear()}-${(
        dataNascimento.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${dataNascimento
          .getDate()
          .toString()
          .padStart(2, '0')}`;

      const dadosPaciente = {
        idLegado: novoPaciente?.idLegado ?? paciente.SEQ_PACIENTE,
        numeroProntuario: novoPaciente?.numeroProntuario ?? paciente.NRO_PRONTUARIO,
        nome: novoPaciente?.nome ?? paciente.NOM_PESSOA,
        dataNascimento: dataNascimentoFormat,
        sexo: novoPaciente?.sexo.value ?? novoPaciente?.sexo ?? paciente.COD_SEXO,
        email: novoPaciente?.email ?? email,
        telefone: novoPaciente?.telefone ?? telefone,
        celular: novoPaciente?.celular ?? celular,
        cpf: novoPaciente?.cpf,
        cns: novoPaciente?.cns,
        nomeMae: novoPaciente?.nomeMae,
        GMR: paciente?.GMR === 'S' ?? undefined,
      };

      const [responsePaciente] = await Promise.all([
        dominioDemandaCirurgica.put(
          `/api/paciente/${novoPaciente?.id ?? paciente.ID}`,
          dadosPaciente
        ),
      ]);

      idPaciente = responsePaciente.data.id;

      const dadosAtendimento = {
        idLegado: atendimento?.SEQ_ATENDIMENTO ?? paciente?.SEQ_ATENDIMENTO,
        dataAtendimento: atendimento?.DAT_HORA_ATENDIMENTO ?? paciente?.DAT_HORA_ATENDIMENTO,
        numeroFAA: atendimento?.NRO_FAA ?? paciente?.NRO_FAA,
        peso: parseInt(peso, 10),
        convenio: convenio.id,
      };

      const [responseAtendimento] = await Promise.all([
        dominioDemandaCirurgica.put(`/api/atendimento/${atendimento.ID}`, dadosAtendimento),
      ]);

      idAtendimento = responseAtendimento.data.id;

      let dataInternacaoFormat;

      if (dataInternacao) {
        dataInternacaoFormat = new Date(dataInternacao);
        dataInternacaoFormat = moment.utc(dataInternacaoFormat).format('YYYY-MM-DD');
      }

      const dadosInternacao = {
        diariasPrevistas: parseInt(diariasPrevistas, 10),
        leitoUTI: leitoUTI === 'true',
        tipoAcomodacao: tipoAcomodacao ? tipoAcomodacao.id : null,
        dataInternacao: internacao ? internacao.dataInternacao : dataInternacaoFormat,
        idLegado: internacao ? internacao.SEQ_INTERNACAO : undefined,
        numeroInternacao: internacao ? internacao.NRO_INTERNACAO : undefined,
        convenio: convenio.id,
        peso: parseInt(peso, 10),
      };

      const [responseInternacao] = await Promise.all([
        dominioDemandaCirurgica.put(
          `/api/internacao/${localStorage.getItem('idInternacao')}`,
          dadosInternacao
        ),
      ]);

      idInternacao = responseInternacao.data.id;
      const dataConferencia = new Date();
      const primeiraConferencia = `${dataConferencia.getFullYear()}-${String(
        dataConferencia.getMonth() + 1
      ).padStart(2, '0')}-${String(dataConferencia.getDate()).padStart(2, '0')} ${String(
        dataConferencia.getHours()
      ).padStart(2, '0')}:${String(dataConferencia.getMinutes()).padStart(2, '0')}:${String(
        dataConferencia.getSeconds()
      ).padStart(2, '0')}`;

      let urlPedido = `api/pedidoCirurgia/${JSON.parse(localStorage.getItem('pedidoCirurgia')).id}`;
      let principaisSinaisSintomas = null;
      let principaisResultadosProvasDiagnosticas = null;
      let recursosNecessariosAtendimentoPaciente = null;
      let historiaClinica = null;
      let areaMedica = null;
      let eOncologica = null;

      await dominioDemandaCirurgica.get(urlPedido).then(response => {
        principaisSinaisSintomas = response.data.principaisSinaisSintomas;
        principaisResultadosProvasDiagnosticas = response.data.principaisResultadosProvasDiagnosticas;
        recursosNecessariosAtendimentoPaciente = response.data.recursosNecessariosAtendimentoPaciente;
        historiaClinica = response.data.historiaClinica;
        areaMedica = response.data?.areaMedica ? response.data.areaMedica.id : null;
        eOncologica = response.data.eOncologica;
      });

      const dadosPedido = {
        atendimento: idAtendimento,
        paciente: idPaciente,
        status: configuracoes.statusRevisaoTecnica,
        motivoRejeicao: '',
        profissionalRequisitante: profissionalRequisitante.id,
        dataHoraSugerida: dataSugerida,
        caraterAtendimento: carater.id,
        profissionalResponsavel: profissionalResponsavel ? profissionalResponsavel.id : null,
        centroCirurgico: centroCirurgico.id,
        salaCirurgia: salaCirurgia?.id ?? 1,
        lateralidade,
        indicacaoClinica,
        cidPrincipal: cidPrincipal.id,
        cidSecundario: cidsSecundarios ? cidsSecundarios.map(cid => cid.id) : [],
        prioridadeCirurgia: prioridade.id,
        internacao: idInternacao,
        tipoAnestesia: tipoAnestesia.id,
        equipeRequisitante: equipeRequisitante.id,
        procedimentoPrincipal: procedimentoPrincipal.id,
        quantidadeProcedimentoPrincipal: procedimentoPrincipal.quantidade,
        procedimentoSecundario: procedimentosSecundarios
          ? procedimentosSecundarios.map(proc => {
            const p = { id: proc.id, quantidade: proc.quantidade };
            return p;
          })
          : [],
        confirmado: 1,
        duracaoEstimada,
        dataInternacao: internacao.idLegado ? internacao.dataInternacao : dataInternacaoFormat,
        motivoAntecipacaoInternacao: motivoAntecipacaoInternacao
          ? motivoAntecipacaoInternacao.id
          : undefined,
        primeiraConferencia,
        codigoLeitoInternacao: parseInt(codigoLeito, 10),
        necessariaAvaliacaoAnestesica,
        motivoAvaliacaoAnestesica,
        modalidadeAtendimento: modalidadeAtendimento.id,
        ano0: null,
        idModeloPedidoCirurgia: localStorage.getItem('idModeloPedidoCirurgia') ? localStorage.getItem('idModeloPedidoCirurgia') : null,
        principaisSinaisSintomas,
        principaisResultadosProvasDiagnosticas,
        recursosNecessariosAtendimentoPaciente,
        historiaClinica,
        areaMedica,
        eOncologica,
      };

      //  Excluindo os procedimentos secundários para gravar de novo (pra manter sempre atualizando)
      await dominioDemandaCirurgica
        .delete(`/api/excluirProcedimentosSecundariosPedidoCirurgia/${pedidoCirurgia.id}`)
        .then(
          () => { },
          () => {
            setLoading(false);
            setMensagemErro('Erro ao confirmar pedido');
            setAbrirMensagemErro(true);
          }
        );

      /*
      await dominioDemandaCirurgica
        .put(`/api/pedidoCirurgia/${pedidoCirurgia.id}`, dadosPedido)
        .then(
          () => { },
          () => {
            setLoading(false);
            setMensagemErro('Erro ao confirmar pedido');
            setAbrirMensagemErro(true);
          }
        );
      */

      let localFinalEfetivoCirurgia = '';
      let fimEfetivo = null;

      if (dataSugerida && duracaoEstimada) {
        fimEfetivo = moment(dataSugerida).add(duracaoEstimada, 'minutes').format('YYYY-MM-DDTHH:mm');
        setFinalEfetivoCirurgia(fimEfetivo);
        localFinalEfetivoCirurgia = fimEfetivo;
      }

      const responsePedido = await Promise.resolve(
        dominioDemandaCirurgica.put(`/api/pedidoCirurgia/${pedidoCirurgia.id}`, dadosPedido).then(
          () => {
            const dadosAgendamentoSalaCirurgia = {
              inicioCirurgia: dataSugerida,
              finalEfetivoCirurgia: finalEfetivoCirurgia ?? localFinalEfetivoCirurgia,
              // pedidoCirurgia: pedidoCirurgia.id,
            };

            Promise.resolve(
              dominioDemandaCirurgica
                .put(`/api/agendamentoSalaCirurgia/${pedidoCirurgia.id}`, dadosAgendamentoSalaCirurgia)
                .then(
                  () => {},
                  () => {
                  setLoading(false);
                  setMensagemErro('Erro ao agendar sala de cirurgia');
                  setAbrirMensagemErro(true);
                  return false;
                })
            );

            if (dataAlterada || centroCirurgicoAlterado || caraterAlterado) {
              const dadosPedidoAgendamento = {
                idStatusPedido: configuracoes?.statusReagendado,
                idMotivoReagendamento: motivoReagendamentoSelecionado?.id,
                idProfissionalReagenda: profissional?.profissional_id,
                dataHoraSugeridaReagendamento: dataSugerida,
                dataInternacaoReagendamento: internacao.idLegado ? internacao.dataInternacao : dataInternacaoFormat,
              };

              Promise.resolve(
                dominioDemandaCirurgica
                  .put(`/api/alterarStatus/${pedidoCirurgia.id}`, dadosPedidoAgendamento)
                  .then(() => {
                    let dataLog = {
                      id_usuario: profissional?.userid,
                      username: profissional?.username,
                      id_pedido: pedidoCirurgia.id,
                      tipo: 'STATUS',
                      descricao: `REAGENDAMENTO - ${motivoReagendamentoSelecionado?.descricao}`,
                    };

                    dominioNODE.post('/logpedido', dataLog).catch(error => {
                      console.log(`ERRO AO INCLUIR LOG: ${error}`);
                    });

                    dominioDemandaCirurgica.delete(`/api/parecerAreaTecnica/${pedidoCirurgia.id}`);
                  })
              );
            }

            return true;
          },
          () => {
            setLoading(false);
            setMensagemErro('Erro ao confirmar pedido');
            setAbrirMensagemErro(true);
            return false;
          }
        )
      );

      if (!responsePedido) return false;

      //  Excluindo os itens para gravar de novo (pra manter sempre atualizando)
      await dominioDemandaCirurgica
        .delete(`/api/excluirItensPedidoCirurgia/${pedidoCirurgia.id}`)
        .then(
          () => { },
          () => {
            setLoading(false);
            setMensagemErro('Erro ao deletar itens do pedido');
            setAbrirMensagemErro(true);
          }
        );

      const listaItens = [];
      if (caixasOPME) {
        caixasOPME.forEach(caixa =>
          listaItens.push({
            item: caixa.id,
            quantidade: caixa.quantidade,
            pedidoCirurgia: pedidoCirurgia.id,
            itemEventual: caixa.itemEventual ?? false,
            justificativaEventual: caixa.justificativaEventual ?? null,
          })
        );
      }
      if (materiaisConsumiveis) {
        materiaisConsumiveis.forEach(material =>
          listaItens.push({
            item: material.id,
            quantidade: material.quantidade,
            pedidoCirurgia: pedidoCirurgia.id,
            itemEventual: material.itemEventual ?? false,
            justificativaEventual: material.justificativaEventual ?? null,
          })
        );
      }
      if (hemoderivados) {
        hemoderivados.forEach(hemoderivado =>
          listaItens.push({
            item: hemoderivado.id,
            quantidade: hemoderivado.quantidade,
            pedidoCirurgia: pedidoCirurgia.id,
            unidadeMedida: hemoderivado.unidadeMedida.id,
          })
        );
      }
      if (equipamentos) {
        equipamentos.forEach(equipamento =>
          listaItens.push({
            item: equipamento.id,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          })
        );
      }
      if (exames) {
        exames.forEach(exame =>
          listaItens.push({
            item: exame.id,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          })
        );
      }
      if (caixasCirurgicas) {
        caixasCirurgicas.forEach(caixa =>
          listaItens.push({
            item: caixa.id,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          })
        );
      }
      if (
        (tipoAcomodacao && tipoAcomodacao.exigeParecerNir) ||
        (dadosPedido.codigoLeitoInternacao ?? 0) > 0
      ) {
        listaItens.push({
          item: configuracoes.itemPadraoExigenciaParecerNir,
          quantidade: 1,
          pedidoCirurgia: pedidoCirurgia.id,
        });
      }

      if (tipoPedido === tipoPedidoSuplementar)
        configuracoes.itensInclusaoAutomaticaSaudeSuplementar.forEach(itemInclusaoAutomatica => {
          listaItens.push({
            item: itemInclusaoAutomatica,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          });
        });

      if (listaItens.length > 0) {
        await Promise.all(
          listaItens.map(async item => {
            dominioDemandaCirurgica.post('/api/itemPedidoCirurgia', item);
          })
        );
      }

      if (!dataAlterada && !centroCirurgicoAlterado && !caraterAlterado) {
        let dataLog = {
          id_usuario: profissional.userid,
          username: profissional.username,
          id_pedido: pedidoCirurgia.id,
          tipo: 'STATUS',
          descricao: 'REVISÃO TÉCNICA',
        };

        dominioNODE.post('/logpedido', dataLog).catch(error => {
          console.log(`ERRO AO INCLUIR LOG: ${error}`);
        });
      }

      let camposAlterados = '';
      camposLOG.forEach(campo => {
        const itemEntrada = String(localStorage.getItem(campo));
        const itemSaida = String(localStorage.getItem(`LOG_${campo}`));

        if (itemEntrada !== itemSaida) {
          camposAlterados = `${campo}:  \
                             ${itemEntrada}`;
          if (camposAlterados) {
            let dataLog = {
              id_usuario: profissional.userid,
              username: profissional.username,
              id_pedido: pedidoCirurgia.id,
              tipo: 'Alteração',
              descricao: camposAlterados,
            };
            dominioNODE.post('/logpedido', dataLog).catch(error => {
              console.log(`ERRO AO INCLUIR LOG: ${error}`);
            });
          }
        }
      });

      limparLocalStorage();
      setRedireciona(true);
    } catch (error) {
      setLoading(false);
      setMensagemErro(`Erro ao confirmar pedido: ${error}`);
      setAbrirMensagemErro(true);
    }
  };

  const renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="Não"
          icon="pi pi-times"
          onClick={() => setDisplayBasica(false)}
          className="p-button-text"
        />
        <ButtonPrime
          label="Sim"
          icon="pi pi-check"
          onClick={() => handleCancelarPedido()}
          autoFocus
        />
      </div>
    );
  };

  const renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => setAbrirMensagemErro(false)}
          autoFocus
        />
      </div>
    );
  };

  const handleSubmitReagendamento = e => {
    e.preventDefault();

    if (motivoReagendamentoSelecionado) {
      setAbreModalReagendar(false);
      handleConfirmarPedido();
    }
  };

  if (redireciona) {
    const { filtroCentroCirurgico, periodoFiltrado } = props.getFiltrosPedidoCirurgia();

    props.listarPedidosCirurgia(filtroCentroCirurgico, periodoFiltrado);
    props.setRenderWizardGerente(false);
    return null;
  }

  return (
    <>
      <DialogPrime
        header={`Confirmar Reagendamento do Pedido Nº ${JSON.parse(localStorage.getItem('pedidoCirurgia')).codigo}`}
        visible={abreModalReagendar}
        style={{ width: '65vw' }}
        onHide={() => {setAbreModalReagendar(false)} }
        closable={false}
      >
        <p>
          {`Ao confirmar o reagendamento, o pedido nº ${JSON.parse(localStorage.getItem('pedidoCirurgia')).codigo} terá seu status alterado.`}
        </p>
        <form onSubmit={e => {handleSubmitReagendamento(e)}}>
          <div>
            <Container className="container-troca-status">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    id="listaMotivosReagendamento"
                    options={listaMotivosReagendamento}
                    getOptionLabel={option => `${option.descricao}`}
                    onChange={(e, value) => {
                      setMotivoReagendamentoSelecionado(value);
                    }}
                    value={motivoReagendamentoSelecionado}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Motivo para Reagendamento"
                        variant="outlined"
                        fullWidth
                        required
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Container>
          </div>
          <div style={{ float: 'right' }}>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginTop: '10px' }}
              type="submit"
            >
              Confirmar
            </Button>
          </div>
        </form>
      </DialogPrime>

      <Toast ref={myToast} />
      <CssBaseline />
      <main className={classes.layout}>
        <Dialog
          header="Cancelar pedido"
          visible={displayBasic}
          style={{ width: '60vw' }}
          footer={renderFooterDisplay()}
          onHide={() => setDisplayBasica(false)}
        >
          <p>Deseja realmente cancelar?</p>
        </Dialog>
        <Dialog
          header="Atenção!"
          visible={abrirMensagemErro}
          style={{ width: '65vw' }}
          onHide={() => setAbrirMensagemErro(false)}
          footer={renderFooterDisplayErro()}
        >
          <div>
            <p>{mensagemErro}</p>
          </div>
        </Dialog>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center" id="centroWizard">
            {`${localStorage.getItem('reagendamento') ? 'Reagendamento Pedido' : 'Pedido de Cirurgia'} nº ${JSON.parse(localStorage.getItem('pedidoCirurgia')).codigo}`}
          </Typography>
          {isMobile ? (
            <div>
              <div className="div-stepper-mobile">
                <strong className="texto-stepper-mobile">{`${activeStep + 1} - `}</strong>
                <span className="texto-stepper-mobile">{steps[activeStep]}</span>
              </div>
              <MobileStepper
                variant="dots"
                steps={steps.length}
                position="static"
                activeStep={activeStep}
                className={classes.root}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === steps.length - 1}
                  >
                    Próximo
                    <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    <KeyboardArrowLeft />
                    Voltar
                  </Button>
                }
              />
            </div>
          ) : (
            <Stepper nonLinear activeStep={activeStep} className={classes.stepper}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepButton
                    disabled={activeStep === steps.length}
                    onClick={handleStep(index)}
                    completed={completed[index]}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          )}
          <>
            {activeStep === steps.length ? (
              <ConfirmacaoPedido />
            ) : (
              <>
                {getStepContent(activeStep)}
                <div
                  className={`${classes.buttons} ${activeStep !== 0 ? 'alinhamento-botoes-wizard' : ''
                    }`}
                >
                  {activeStep !== 0 && (
                    <Button
                      onClick={handleBack}
                      className={classes.button}
                      color="default"
                      variant="contained"
                    >
                      Anterior
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={
                      activeStep === steps.length - 1 ? handleConfirmarPedido : handleComplete
                    }
                    className={classes.button}
                    style={{ float: `` }}
                  >
                    {loading ? (
                      <FaSpinner color="#FFF" className="loading" size={14} />
                    ) : (
                      <>{activeStep === steps.length - 1 ? 'Enviar' : 'Próximo'}</>
                    )}
                  </Button>
                </div>
              </>
            )}
          </>
        </Paper>
      </main>
    </>
  );
}
